import { Params } from 'app/types';

import { request } from '../config';

export function apiGetMerchantAccount(id: string, stripeAccountName: string): Promise<any> {
  return request(
    {
      url: `companies/${id}/merchant-accounts.json?stripe_account_name=${stripeAccountName}`,
      method: 'GET',
    },
    (data) => data.model
  );
}

export function apiGetMerchantAccountConnectLink(id: string, returnUrl: string, stripeAccountName: string): Promise<Params> {
  return request(
    {
      url: `companies/${id}/merchant-accounts.json`,
      method: 'POST',
      data: {
        return_url: returnUrl,
        stripe_account_name: stripeAccountName,
      },
    },
    (data) => data.model
  );
}

export function apiGetMerchantAccountDashboardLink(id: string, returnUrl: string): Promise<Params> {
  return request(
    {
      url: `companies/${id}/merchant-accounts/stripe-dashboard-url.json`,
      method: 'GET',
      params: {
        return_url: returnUrl,
      },
    },
    (data) => data.model
  );
}

export function apiDeleteMerchantAccount(id: string): Promise<string> {
  return request(
    {
      url: `companies/${id}/merchant-accounts.json`,
      method: 'DELETE',
    },
    (data) => data.model.id
  );
}
